import React from 'react';

import './BackButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export const BackButton = ({ onClick }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div className="back-button-container" onClick={handleClick}>
      <button className="back-button">
        <div>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
      </button>
    </div>
  );
};
